import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Upload, File, X, CheckCircle, AlertCircle } from 'lucide-react';
interface UploadZoneProps {
  onFilesAccepted: (files: File[]) => void;
  accept?: Record<string, string[]>;
  maxSize?: number;
  multiple?: boolean;
}
export function UploadZone({
  onFilesAccepted,
  accept = {
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'text/csv': ['.csv']
  },
  maxSize = 50 * 1024 * 1024,
  // 50MB
  multiple = true
}: UploadZoneProps) {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    onFilesAccepted(acceptedFiles);
  }, [onFilesAccepted]);
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject
  } = useDropzone({
    onDrop,
    accept,
    maxSize,
    multiple
  });
  return <div {...getRootProps()} className={`
        border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors
        ${isDragActive && !isDragReject ? 'border-blue-500 bg-blue-50' : ''}
        ${isDragReject ? 'border-red-500 bg-red-50' : ''}
        ${!isDragActive && !isDragReject ? 'border-gray-300 hover:border-blue-400' : ''}
      `} data-id="element-2148">
            <input {...getInputProps()} data-id="element-2149" />
            <div className="flex flex-col items-center gap-2" data-id="element-2150">
                <Upload className={`w-12 h-12 ${isDragActive ? 'text-blue-500' : 'text-gray-400'}`} data-id="element-2151" />
                {isDragActive ? <p className="text-blue-600 font-medium" data-id="element-2152">Drop files here...</p> : isDragReject ? <p className="text-red-600 font-medium" data-id="element-2153">Some files will be rejected</p> : <>
                        <p className="text-gray-700 font-medium" data-id="element-2154">
                            Drag & drop files here, or click to browse
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-2155">
                            PDF, Word, Excel, or CSV files up to 50MB
                        </p>
                    </>}
            </div>
        </div>;
}